module.exports = __webpack_public_path__ + "static/media/block.6d67628f.png";